import { css, CSSResult } from 'lit'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const cseDivider = {
  borderColor: css`var(--cse-divider-border-color, ${csColorBorder.light})`,
  width: css`var(--cse-divider-width, ${csBorder.width})`,
  margin: css`var(--cse-divider-margin, 0)`,
}

export const style: CSSResult = css`
  :host {
    position: relative;
    --internal-border-style: solid;
  }

  :host([orientation="horizontal"]) {
    border-top-width: ${cseDivider.width};
    border-top-style: var(--internal-border-style);
    border-top-color: ${cseDivider.borderColor};
    display: block;
    margin-inline: ${cseDivider.margin};
    width: 100%;
  }

  :host([orientation="vertical"]) {
    border-left-width: ${cseDivider.width};
    border-left-style: var(--internal-border-style);
    border-left-color: ${cseDivider.borderColor};
    display: inline-block;
    margin-block: ${cseDivider.margin};
    min-height: 100%;
  }

  :host([variant="dashed"]) {
    --internal-border-style: dashed;
  }
`
